/**
 * Bootstrap-only DOM integration; the generic renderer does not import it.
 */
export { createTableV2HighlightsStrategy } from './create-table-v2-highlights-strategy.ts';
export { TableV2GeometryResolver } from './table-v2-geometry-resolver.ts';
